import { IconProps } from "./";
import Icon from "./assets/check_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Check(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
